module.exports = __webpack_public_path__ + "assets/images/glasses-03.f9a24f3e0d05d84813e91003bafec665.svg";